const mapping: Record<string, string> = {
  id: 'ds=>ds.Id',
  key: 'ds=>ds.Key',
  value: 'ds=>ds.Value',
  type: 'ds=>ds.Type',
}

export const mapSortDynamicStatisticParametersParam = (key: string) =>
  mapping[key]
